import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

type DeleteInterventionAttachmentPayload = {
  intervention_attachment_id: number;
  intervention_id: number;
};

export const useDeleteInterventionAttachmentMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: DeleteInterventionAttachmentPayload) => {
      await ApiInstance.post("/interventions/attachment/delete", payload);
    },
    onSuccess: ({ intervention_id, intervention_attachment_id }) => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.interventions) return;

      const interventionIdx = appointment.interventions.findIndex(({ id }) => id === intervention_id);
      if (interventionIdx < 0) return;

      const intervention = appointment.interventions[interventionIdx];
      if (!intervention.attachments?.length) return;

      const attachmentIdx = intervention.attachments.findIndex(({ id }) => id === intervention_attachment_id);
      if (attachmentIdx < 0) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
        ...appointment,
        interventions: appointment.interventions.with(interventionIdx, { ...intervention, attachments: intervention.attachments.toSpliced(attachmentIdx, 1) })
      });
    }
  });
